import client from "./client";

export default {
  download: async (url, fileName) => {
    let response;
    try {
      response = await client.get(url, { responseType: "blob" });
    } catch {
      return;
    }
    const header = response.headers["content-disposition"];
    const downloadName = header?.split("filename=")[1]?.split(";")[0]?.replace(/"/g, "");
    const blobUrl = URL.createObjectURL(response.data);
    const link = document.createElement("a");
    link.target = "_blank";
    link.rel = "noopener";
    link.href = blobUrl;
    if (downloadName || fileName) link.download = downloadName || fileName;
    link.click();
    URL.revokeObjectURL(blobUrl);
  },
};
